/**
 * Element.closest() polyfill
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
 */
if (!Element.prototype.closest) {
	if (!Element.prototype.matches) {
		Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
	}
	Element.prototype.closest = function (s) {
		var el = this;
		var ancestor = this;
		if (!document.documentElement.contains(el)) return null;
		do {
			if (ancestor.matches(s)) return ancestor;
			ancestor = ancestor.parentElement;
		} while (ancestor !== null);
		return null;
	};
}

// PDP - The Gisou Story
const PDP = function() {
    const $ = window.jQuery;

    const initGisouStory = (desktopOnly = true, heightOffset = 4) => {
        if (desktopOnly && isDesktop()) {
            adjustStorySectionTabs(heightOffset);
        }
    }

    const adjustStorySectionTabs = (heightOffset) => {
        const storySectionEl = document.querySelector('.gs-story-section');

        const updateTabWrapperHeight = (storySectionEl) => {
            const tabsWrapperEl = storySectionEl.querySelector('.wrapper_tabcontent');
            const imageTabEl = storySectionEl.querySelector('.tab-image.active');
            const tabLinksWrapperEl = storySectionEl.querySelector('.tabs');
            if (imageTabEl) {
                tabsWrapperEl.style.minHeight = (imageTabEl.offsetHeight - tabLinksWrapperEl.offsetHeight - heightOffset) + 'px';
            }
        }

        if (storySectionEl) {
            const tabEls = storySectionEl.querySelectorAll('.tablinks-story');

            tabEls.forEach(tabEl => {
                tabEl.addEventListener('click', (e) => {
                    updateTabWrapperHeight(storySectionEl);
                });
            });

            updateTabWrapperHeight(storySectionEl, tabEls[0]);
        }
    }

    const isDesktop = () => {
        return window.innerWidth > 768;
    }

    var $videoWrapper = document.querySelectorAll('[data-video-wrapper]');
    $videoWrapper.forEach(($wrapper) => {
        var $v_wrapper = $wrapper.closest('.product-link__visual').querySelector('.product-link__cover');
        var $visual_wrapper = $wrapper.closest(".product-link__visual");
        var video;
        if ($v_wrapper) {
          $v_wrapper.addEventListener('mouseover', () => {
              video = $wrapper.querySelector('video');
              video.play();
          })
          $v_wrapper.addEventListener('mouseleave', () => {
              video.pause();
          })
          $v_wrapper.addEventListener("touchstart", (event) => {
            if (!$visual_wrapper.classList.contains("hover")) {
              event.preventDefault();
              event.stopPropagation();
              $visual_wrapper.classList.add("hover");
              return false;
            }
          });
        }
    })

    this.initGisouStory = initGisouStory;

}

const docReadyCallback = () => {
    const pdp = new PDP();
    pdp.initGisouStory();
};

if ( document.readyState === "complete" || ( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
    docReadyCallback();
} else {
    document.addEventListener("DOMContentLoaded", docReadyCallback);
}

// Extra cart drawer functions
var is_update = true;
window.addFreeSampleItem = function(e) {
    const elem = $(e);
    if (elem.hasClass("clicked")) {
      return false;
    }
    if(!is_update) {
      return false;
    }

    $(".free-sample-item").addClass("clicked");
    var id = elem.closest(".free-sample-item").attr("data-id");
    var qty = 1;

    if ($(this).hasClass("active")) {
        qty = 0;
        cartItemUpdate(id, qty);
    } else {
        is_update = false;
        let lists = {};
        $(".free-sample-item").each(function () {
            if ($(this).attr("data-id") != id) {
            $(this).removeClass("active");
            lists[$(this).attr("data-id")] = 0;
            }
        });
        $(e).addClass("active");
        jQuery.post("/cart/update.js", { updates: lists }).done(function () {
            let items = [];
            var item = {
              quantity: 1,
              id: id,
              properties: { _free_gift_product_sample: 1 },
            };
            items.push(item);
            $.post("/cart/add.json", {items: items}).done(function () {
                $(".free-sample-item").removeClass("clicked");
                var cartEvent = new CustomEvent("ajaxcart:open", {detail: "cart",});
                document.dispatchEvent(cartEvent);
                updateFreeSampleItemPosition();
            });
            setTimeout(() => {
                is_update = true;
            }, 500);
        });
    }
    return false;
}

const updateFreeSampleItemPosition = () => {
    return new Promise((resolve, reject) => {
        $.getJSON("/cart.js", function(data) {
          let newItems = [];
          let freeSampleItems = [];
          if (data.items.length > 0) {
            data.items.reverse().forEach(function(item) {
                let cartItem = {
                    quantity: item.quantity,
                    id: item.variant_id,
                    properties: item.properties
                }
                if (item.properties?._free_gift_product_sample != undefined) {
                    freeSampleItems.push(cartItem);
                } else {
                    newItems.push(cartItem);
                }
            });
            // $.post("/cart/clear.js").done(function () {
            //     $.post("/cart/add.json", {items: freeSampleItems.concat(newItems)}).done(function () {
            //       console.log("Cart items order inverted");
            //       resolve(true);
            //     });
            // });
          } else {
            resolve(true);_free_gift_product_sample
          }
        });
    });
}

window.updateFreeSampleItemPosition = updateFreeSampleItemPosition;

const removeFreeSampleItem = () => {
    var cartFreeSampleItemArr = [];
    for (const item of document.querySelectorAll('[data-ajax-cart-template-element="price"]')) {
        if (item.textContent.includes('FREE')) {
        cartFreeSampleItemArr.push(item)
        }
    }
    if (window.cart.cartItems.length == cartFreeSampleItemArr.length && cartFreeSampleItemArr.length > 0) {
        document.querySelectorAll('[data-ajax-cart-template-element="remove"]').forEach((ele) => {
            ele.click();
        });
    }
}

const isScrolledIntoView = ($el) => {
    var rect = $el.getBoundingClientRect();
    var elemTop = rect.top;
    var elemBottom = rect.bottom;
// Only completely visible elements return true:
    // var isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
    // Partially visible elements return true:
    isVisible = elemTop < window.innerHeight && elemBottom >= 0;
    return isVisible;
}

const VideoPlay = () => {
    var $video_elements = document.querySelectorAll('.media_wrapper .embed_wrapper');
    $video_elements.forEach(($el) => {
        var $iframe = $el.querySelector('iframe');
        var $video = $el.querySelector('video');
        if(isScrolledIntoView($el)) {
            if($iframe) {
                if($iframe.getAttribute('data-play') == 'true') {
                    return;
                }
                var src = $iframe.getAttribute('src');
                if(!src.includes('autoplay')) {
                    if(src.includes('?')) {
                        src += '&autoplay=1';
                    }
                    else {
                        src += '?autoplay=1'
                    }
                    if(!src.includes('muted=1')) {
                        src += '&muted=1';
                    }
                }
                $iframe.setAttribute('src', src);
                $iframe.setAttribute('data-play', 'true');
            }
            if($video) {
                $video.play();
            }
        }
        else {
            if($iframe) {
                var src = $iframe.getAttribute('src');
                src = src.replace('&autoplay=1', '').replace('?autoplay=1&', '?').replace('?autoplay=1', '?');
                $iframe.setAttribute('src', src);
                $iframe.setAttribute('data-play', 'false');
            }
            if($video) {
                $video.pause();
            }
        }
    })
}

window.addEventListener('DOMContentLoaded', (event) => {
    document.addEventListener('scroll', () => {
        VideoPlay();
    })
    VideoPlay();
});

document.querySelectorAll('.video-slider-wrapper').forEach(($sliderWrapper) => {
    $sliderWrapper.querySelector('.swiper-button--custom.swiper-button--next').addEventListener('click', () => {
        // $sliderWrapper.querySelector('div.swiper-button-next').click();
        setTimeout(function() {
            let $target = $sliderWrapper.querySelector('.swiper-slide-active [data-play]');
            if($target) {
                $target.setAttribute('data-play', 'false');
            }
            VideoPlay();
        }, 1500);
    })
    $sliderWrapper.querySelector('.swiper-button--custom.swiper-button--prev').addEventListener('click', () => {
        setTimeout(function() {
            let $target = $sliderWrapper.querySelector('.swiper-slide-active [data-play]');
            if($target) {
                $target.setAttribute('data-play', 'false');
            }
            VideoPlay();
        }, 1500);
        // $sliderWrapper.querySelector('div.swiper-button-prev').click();
    })
})

document.querySelectorAll('.product-sticky-form').forEach(($form) => {
    const $button = $form.querySelector('button');
    if($button) {
        $button.addEventListener('click', () => {
            let items = [];
            var item = {
              quantity: 1,
              id: $form.querySelector('[name="id"]').value
            };

            items.push(item);
            $.post("/cart/add.json", {items: items}).done(function (data) {
                trackStickyAtc($form.dataset.variantUrl);
                document.body.classList.add('ajax-cart-is-open');
                document.dispatchEvent(new CustomEvent('ajaxcart:open'));
            });
        })
    }
})

const trackStickyAtc = (variant_url) => {
    $.ajax({
        url: "".concat(variant_url, "&view=ajax"),
        type: "GET",
        error: function error(_error) {
            if ($.code.debug) {
            console.log("handleTrackingEvent GET product error:", _error);
            }
        },
        }).done(function (product_data) {
        if ($.code.debug) {
            console.log(
            "handleTrackingEvent Get product success:",
            JSON.parse(product_data)
            );
        } // parse the received product data

        var parsed_data = JSON.parse(product_data); // create datalayer object

        var item = parsed_data.current_product_data;
        var products = [
            {
            item_name: parsed_data.product_data.title,
            item_id: item.barcode,
            price:
                item.compare_at_price != null && item.compare_at_price > item.price
                ? Shopify.formatMoney(item.compare_at_price, "{{amount}}")
                : Shopify.formatMoney(item.price, "{{amount}}"),
            item_brand: parsed_data.product_data.vendor,
            quantity: 1,
            item_category: parsed_data.product_data.type,
            item_variant: item.id,
            currency: Shopify.currency.active,
            discount:
                item.compare_at_price != null && item.compare_at_price > item.price
                ? Shopify.formatMoney(
                    item.compare_at_price - item.price,
                    "{{amount}}"
                    )
                : "0.0",
            },
        ];

        let item_data = products[0];

        var data = {
            event: 'add_to_cart',
            ecommerce: {
            currency: Shopify.currency.active,
            value: item_data.price || 0,
            items: products,
            },
        }; // push the datalayer

        if ($.code.debug) {
            console.log("handleTrackingEvent datalayer push:", data);
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push(data);
    });
}

const targetNode = document.body;

// Create an observer instance linked to the callback function
if (window.innerWidth > 769) {
    const searchconfig = { attributes: true };
    // Callback function to execute when mutations are observed
    const searchcallback = (mutationList, observer) => {
        mutationList.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                // handle class change
                setTimeout(() => {
                    if (document.querySelectorAll('.aa-Panel').length > 0) {
                        if (mutation.target.className.includes('search-open')) {
                            document.querySelector('.aa-Panel').style.display = 'block'
                        } else {
                            document.querySelector('.aa-Panel').style.display = 'none'
                        }
                    }
                }, 1000)
            }
        });
    };
    const observer = new MutationObserver(searchcallback);
    observer.observe(targetNode, searchconfig);
}



if(window.innerWidth < 769) {
    // Options for the observer (which mutations to observe)
    const config = { attributes: true, childList: true, subtree: true };
    // Callback function to execute when mutations are observed
    const callback = (mutationList, observer) => {
        let aaDetachBody = document.querySelector('body.aa-Detached');
        if(!aaDetachBody) {
            document.body.classList.remove('search-open');
            observer.disconnect();
        }
    };
    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);
    document.addEventListener('click', (e) => {
        if(e.target.getAttribute('class') == 'aa-DetachedCancelButton') {
            observer.observe(targetNode, config);
        }
        if (e.target.className?.includes('search-toggle') || e.target.closest('.search-toggle')?.className.includes('search-toggle')) {
            document.querySelector('.aa-DetachedSearchButton').click();
        }
    });
}

// Remove Yotpo rich snippet from head
const removeYotpoSnippetObserver = new MutationObserver((mutationList, observer) => {
  let yotpoSnippet = document.querySelector('script.y-rich-snippet-script');
  if (yotpoSnippet) {
    yotpoSnippet.remove();
    observer.disconnect();
  }
});

removeYotpoSnippetObserver.observe(document.querySelector('head'), { attributes: true, childList: true, subtree: true });

const sideMenuToggle = () => {
    document.querySelectorAll('.menu-back').forEach((menuBackEl) => {
        menuBackEl.addEventListener('click', () => {
            let collapsibleParent = menuBackEl.closest('[data-collapsible-parent]');
            collapsibleParent.classList.remove('collapsible__is-open');
            if(collapsibleParent.classList.contains('level-1')) {
                let headerNav = document.querySelector('.header-navigation.nav-expanded');
                if(headerNav) {
                    headerNav.classList.remove('nav-expanded');
                }
            }
        })
    })
    document.querySelector('.sidebar-bg-overlay').addEventListener('click', () => {
        let active_nav = document.querySelector('.sidebar-bg-overlay').closest('.header-wrapper').querySelector('.header-nav-list-item.collapsible__is-open');
        if(active_nav) {
            active_nav.classList.remove('collapsible__is-open');
        }
        document.body.classList.toggle('header-nav__is-open');
    })
}

sideMenuToggle();
removeFreeSampleItem();

document.querySelectorAll('.search-toggle').forEach((searchEl) => {
    searchEl.addEventListener('click', () => {
        setTimeout(function() {
            $(".aa-Input").focus();
            if (document.querySelector('body.aa-Detached') && locale == 'fr') {
                document.querySelector('.aa-DetachedCancelButton').innerText = 'Annuler'
            } else {
                document.querySelector('.aa-DetachedCancelButton').innerText = ''
                document.querySelector('.aa-ClearButton').innerText = 'Clear'
            }
        }, 500);


    })
})

let headerNav = document.querySelector('.header-navigation.header-navigation--mobile');

document.querySelector('.country-button').addEventListener('click', e => {
    let countrySelWrapper = document.querySelector('.country-selector-wrapper');
    countrySelWrapper.classList.toggle('isopen-content');
    headerNav.classList.add('nav-expanded');
})

document.querySelector('.country-selector-wrapper .menu-back').addEventListener('click', e => {
    document.querySelector('.country-selector-wrapper').classList.remove('isopen-content');
    headerNav.classList.remove('nav-expanded');
})

document.querySelector('.language-selector-wrapper .menu-back').addEventListener('click', e => {
    document.querySelector('.language-selector-wrapper').classList.remove('isopen-content');
    headerNav.classList.remove('nav-expanded');
})

// Added from v3 updates.

const initCollectionTabs = () => {
    let el = {
        tabHeader: '.collection-tab-header .tab-header',
        tabHeaderActive: '.collection-tab-header .tab-header.active',
        tabContent: '.collection-tab-content .tab-content',
        tabContentActive: '.collection-tab-content .tab-content.active'
    }
    document.querySelectorAll(el.tabHeader).forEach((tabHeader) => {
        tabHeader.addEventListener('click', () => {
            var container = tabHeader.closest('.section-featured-collections');
            var handle = tabHeader.getAttribute('data-target');
            container.querySelector(el.tabHeaderActive).classList.remove('active');
            container.querySelector(el.tabContentActive).classList.remove('active');

            tabHeader.classList.add('active');
            container.querySelector(`${el.tabContent}[data-handle="${handle}"]`).classList.add('active');
        })
    })
}

initCollectionTabs();

const initTabBlocks = () => {
    let el = {
        tabWrapper: '.tab-blocks',
        tabBlock: '.tab-block',
        tabButton: '.tab-button',
        activeTab: '.tab-block.active',
        swiperTriggerNext: '.swiper-next-trigger',
        swiperTriggerPrev: '.swiper-prev-trigger'
    }
    document.querySelectorAll(el.tabButton).forEach((button) => {
        button.addEventListener('click', () => {
            const tabWrapper = button.closest(el.tabWrapper);
            const c_tab = tabWrapper.querySelector(el.activeTab);
            const n_tab = tabWrapper.querySelector(`${el.tabBlock}[data-handle="${button.getAttribute('data-target')}"]`);
            c_tab.classList.remove('active');
            n_tab.classList.add('active');
        })
    })
    document.querySelectorAll(el.swiperTriggerPrev).forEach((trigger) => {
        trigger.addEventListener('click', () => {
            trigger.closest('.swiper').querySelector('.swiper-button.swiper-button--prev').click();
        })
    })
    document.querySelectorAll(el.swiperTriggerNext).forEach((trigger) => {
        trigger.addEventListener('click', () => {
            trigger.closest('.swiper').querySelector('.swiper-button.swiper-button--next').click();
        })
    })
}

initTabBlocks();

const initBAslider = () => {
    let el = {
        BAcontainer: '.BAslide--container',
        BAslider: '.slider'
    }
    const container = document.querySelectorAll(el.BAcontainer);
        container.forEach((_container) => {
        _container.querySelector(el.BAslider).addEventListener('input', (e) => {
            _container.style.setProperty('--position', `${e.target.value}%`);
        })
    })
}

initBAslider();

const ingredientCardFlip = () => {
    document.querySelectorAll('.card-flip-trigger').forEach((trigger) => {
        trigger.addEventListener('click', () => {
            if(trigger.closest('.swiper-slide-active')) {
                trigger.closest('.ingredient-flip-card').classList.toggle('flipped');
            }
        })
    })
}

ingredientCardFlip();

const jsQuickView = () => {
    document.querySelectorAll('.upsell-item .quick-view-trigger').forEach((item) => {
        item.addEventListener('click', () => {
            const qvEl = item.querySelector('.product-quick-view-open');
            if(qvEl) {
                qvEl.click();
            }
        })
    })
    document.querySelectorAll('.product-quick-view-open').forEach((button) => {
        button.addEventListener('click', () => {
            const handle = button.getAttribute('data-handle');
            fetch(`/products/${handle}?view=quick-view`, {
                method: 'GET',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Request failed');
                }
                return response.text();
            })
            .then(data => {
                openQuickView('product-quick-view', data);
            })
            .catch(error => {
                console.error('Error:', error);
            });
        })
    })
  
    document.querySelectorAll('.js-popup-open').forEach((openEl) => {
        openEl.addEventListener('click', () => {
            openQuickView(openEl.getAttribute('data-target'), null);
        })
    })
  
    document.querySelectorAll('.js-popup .bg-overlay, .quick-view-close').forEach((closeEl) => {
        closeEl.addEventListener('click', () => {
            closeQuickView(closeEl.closest('.js-popup'));
        })
    })
  
    $(document).on('click', '.js-popup .product-quick-atc button', (e) => {
        e.target.closest('.quick-view-wrapper').querySelector('button.quick-view-close').click();
    })
  
    $(document).on('click', '.js-popup .quick-view-wrapper a', (e) => {
        e.target.closest('.quick-view-wrapper').querySelector('button.quick-view-close').click();
    })
}
  
function openQuickView(handle, content) {
    const popupEl = document.querySelector(`.js-popup[data-handle="${handle}"]`);
    const wrapperEl = popupEl.querySelector('.quick-view-wrapper .quick-view-content');
    popupEl.classList.add('visible');
    if(content != null) {
        wrapperEl.innerHTML = content;
    }
    if(handle == 'product-quick-view') {
        var api = new Yotpo.API(yotpo);
        api.refreshWidgets();
    }
    setTimeout(() => {
        popupEl.classList.add('open');
    });
    document.body.classList.add('popup-open');
}
  
function closeQuickView (popupEl) {
    popupEl.classList.remove('open');
    setTimeout(() => {
        popupEl.classList.remove('visible');
    }, 300);
    document.body.classList.remove('popup-open');
}

jsQuickView();

const initStickyAtcVisible = () => {
    let el = {
        button: '.product-form [data-button]',
        productOffer: '.product-offer',
        headerWrapper: '.header#header'
    }
    let $button = document.querySelector(el.button);
    let $productOffer = document.querySelector(el.productOffer);
    let $headerWrapper = document.querySelector(el.headerWrapper);
  
    function checkProductFormScrollState() {
        if(isScrolledIntoView($button)) {
            $productOffer.classList.remove('product-offer--active');
        }
        else {
            $productOffer.classList.add('product-offer--active');
        }
    }

    if ($productOffer) {
        $(window).on('scroll resize', function () {
            checkProductFormScrollState();
        }); 
        checkProductFormScrollState();
    }
}

initStickyAtcVisible();
const initWishlist = () => {
    if (!window.SwymCallbacks) {
        window.SwymCallbacks = [];
    }
    
    window.SwymCallbacks.push(checkWishlistItemCount);
    window.SwymCallbacks.push(checkWishlistAPI);
    checkWishlistAPI();
    
    function checkWishlistItemCount(swat){
        swat.fetch(function(products) {
            if(products.length > 0) {
                document.querySelector('.header-nav-link-wrapper .swym-wishlist').classList.add('has-list');
            }
            else {
                document.querySelector('.header-nav-link-wrapper .swym-wishlist').classList.remove('has-list');
            }
            document.querySelectorAll('.wishlist-item-count').forEach((count) => {
                count.innerText = products.length;
                count.classList.remove('hidden');
            })
        })
    }
    
    function checkWishlistAPI() {
        const per_observer = new PerformanceObserver((list) => {
            for (const entry of list.getEntries()) {
                if (entry.initiatorType == "xmlhttprequest") {
                    if(entry.name.includes('/recordWishlistAction') || entry.name.includes('/epiRecordWishlist')) {
                        window.SwymCallbacks.push(checkWishlistItemCount);
                    }
                }
            }
        });
        per_observer.observe({entryTypes: ["resource"]});
    }
}

const initRedirect = () => {
    if (window.location.pathname == "/collections" || window.location.pathname == "/collections/" || window.location.pathname == "/products" || window.location.pathname == "/products/" ) {
        window.location.href = "/collections/shop-all"
    }
}

initWishlist();
initRedirect();


const initClearForMe = () => {
    // ClearForMe init

    var el = {
        ingSelectedTitle: '[data-ingredient-selected-title]',
        ingSelectedContent: '[data-ingredient-selected-content]',
        ingList: '[data-ingredient-list]'
    }

    let el_list = document.querySelector(el.ingList);
    if(!el_list) {
        return;
    }

    var cfm_options = {
        clientName: 'gisou',
        bearerToken: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2MGRlMTAxYzI1ODg2NTAwMjJhZjM5MjAiLCJjbGllbnRuYW1lIjoiZ2lzb3UiLCJ1c2VybmFtZSI6Imdpc291IiwicGFzc3dvcmQiOiIkMmEkMTAkMWdnRGNXNmsxNU1HNUovRVhqb0p5T1dpM3AzODRlT095NUEzSXBzSDBCckJ0ZGpFNVlzcU8iLCJlbWFpbCI6Im5vdXJlZW4rZ2lzb3VAY2xlYXJmb3JtZS5jb20iLCJpc0FkbWluIjp0cnVlLCJzdXBlckFkbWluIjpmYWxzZSwicGFja2FnZSI6InBybyBicmFuZCIsInBlcm1pc3Npb24iOiJvd25lciIsImlhdCI6MTYyNTE2NjY0OH0.p3gPydbAz933JVTiiRMuzN4QpW5jegMTrvx12u0E4pQ',
        sku: el_list.dataset.selectedSku
    }

    function initCFM() {
        var url = 'https://server.clearforme.com/api/app/products/details?sku=' + cfm_options.sku + '&clientname=' + cfm_options.clientName;
        fetch(url, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': cfm_options.bearerToken
            }
        }).then(res => res.json())
        .then((response) => {
            var ingListStr = '';
            if(!response.productIngredients) {
                return;
            }
            response.productIngredients.forEach((pIngredients) => {
                pIngredients.functionGroup.forEach((fGroup) => {
                    fGroup.ingredients.forEach((ingredient, idx) => {
                        ingListStr += `<span class="${idx == 0 ? 'active': ''}" data-ingredient="${ingredient.ingredientName}">${ingredient.ingredientName}</span>, `;
                        if(idx == 0) {
                            getIngItem(ingredient.ingredientName);
                        }
                    })
                })
            })
            ingListStr = ingListStr.slice(0, -2);
            document.querySelector(el.ingList).innerHTML = ingListStr;
            document.querySelectorAll(`${el.ingList} span`).forEach((ingBtn) => {
                ingBtn.addEventListener('click', () => {
                    getIngItem(ingBtn.getAttribute('data-ingredient'));
                    document.querySelector(`${el.ingList} span.active`).classList.remove('active');
                    ingBtn.classList.add('active');
                })
            })
        })
    }

  function getIngItem(ingredientName) {
    var url = 'https://server.clearforme.com/api/app/ingredients/definition?sku=' + cfm_options.sku + '&ingredientName=' + ingredientName + '&clientname=' + cfm_options.clientName;
    fetch(url, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': cfm_options.bearerToken
      }
    }).then(res => res.json())
    .then((response) => {
      document.querySelector(el.ingSelectedTitle).innerHTML = ingredientName;
      document.querySelector(el.ingSelectedContent).innerHTML = response.definition;
    })
  }

  initCFM();
}

initClearForMe();


const initVariantSwatchChange = () => {

    const selector = {
        v_select: '[data-product-select]',
        swatch: '[data-single-option-selector]'
    }

    document.querySelectorAll(selector.swatch).forEach((swatch) => {
        swatch.addEventListener('change', ()=> {

            let v_id = document.querySelector(selector.v_select).value || location.href.split('?variant=')[1];
            let cur_mf_state = get_mf_available(v_id);
          
            setTimeout(() => {
                let new_v_id = document.querySelector(selector.v_select).value || location.href.split('?variant=')[1];
                if(get_mf_available(new_v_id) || cur_mf_state != get_mf_available(new_v_id)) {
                    updateSectionContent();
                }
                else {
                    updateSectionContent(true);
                }

            }, 300);


            // Hide swatch for unavailable variants
            swatchVisible(swatch);
            
        })
    })

    let is_set_visible = false;
    document.querySelectorAll('.product-variants [data-single-option-selector][checked]').forEach((active_opt) => {
        if(active_opt.dataset.optionName != 'size' && is_set_visible == false) {
            swatchVisible(active_opt);
            is_set_visible = true;
        }
    })

    function swatchVisible(swatch) {

        let index = swatch.dataset.index;
        let target_idx = 'option1';
        if(index == 'option1') {
            target_idx = 'option2';
        }

        document.querySelectorAll(`${selector.swatch}[data-index="${target_idx}"]`).forEach((target_swatch) => {
            let target_opt = document.querySelector(`#product-v-select option[data-${index}="${swatch.value}"][data-${target_idx}="${target_swatch.value}"]`);
            let target_opt_name = target_swatch.dataset.optionName;
            if(target_opt && target_opt.dataset.disabled != 'true') {
                target_swatch.removeAttribute('data-visible');
                if(target_opt_name == 'scent' || target_opt_name == 'shade') {
                    document.querySelectorAll(`.${target_opt_name}-item-variant[data-value="${target_swatch.value}"]`).forEach((opt) => {
                        opt.removeAttribute('data--hidden');
                    });
                }
            }
            else {
                target_swatch.setAttribute('data-visible', 'hidden');
                if(target_opt_name == 'scent' || target_opt_name == 'shade') {
                    document.querySelectorAll(`.${target_opt_name}-item-variant[data-value="${target_swatch.value}"]`).forEach((opt) => {
                        opt.setAttribute('data--hidden', true);
                    });
                }
            }
        })
    }

    function get_mf_available(id) {
        let is_mf_available = false;
        document.querySelectorAll('#product-v-select option').forEach((opt) => {
            if(opt.dataset.id == id && opt.dataset.mfAvailable == 'true') {
                is_mf_available = true;
            }
        })
        return is_mf_available;
    }

}

initVariantSwatchChange();


const initToggleMiniIngredient = () => {
    document.querySelectorAll('.mini-ingredient-item button').forEach((item) => {
        item.addEventListener('click', () => {
            let handle = item.dataset.tabsLink;
            let target = document.querySelector(`.tabs-content-pane[data-tabs-content-pane="${handle}"]`);

            item.classList.toggle('is-active');
            target.classList.toggle('is-active');
        })
    })
}


const initProductDescToggle = () => {
    const desc_collapsed = document.querySelector('.product-header__description.desc-collapsed');
    const desc_expanded = document.querySelector('.product-header__description.desc-expanded');
    
    const btn_read_more = document.querySelector('.lear_more_link');
    const btn_read_less = document.querySelector('.lear_less_link');

    btn_read_more.addEventListener('click', () => {
        desc_collapsed.classList.add('hidden');
        desc_expanded.classList.remove('hidden');

        btn_read_more.classList.add('hidden');
        btn_read_less.classList.remove('hidden');
    })

    btn_read_less.addEventListener('click', () => {
        desc_collapsed.classList.remove('hidden');
        desc_expanded.classList.add('hidden');
        
        btn_read_more.classList.remove('hidden');
        btn_read_less.classList.add('hidden');
    })
}


const initProductShadeToggle = () => {
    
    let shade_dropdown = document.querySelector('.shade-dropdown');
    if(shade_dropdown) {
        document.documentElement.addEventListener('click', (e) => {
        if(e.target.closest('.active-shade')) {
            shade_dropdown.classList.toggle('visible');
            document.body.classList.toggle('popup-open');
        }
        else {
            if(e.target.closest('.bg-overlay') || e.target.closest('.shade-close') || !e.target.closest('.shade-selector')) {
            shade_dropdown.classList.remove('visible');
            document.body.classList.remove('popup-open');
            }
        }
        })
    }

    document.querySelectorAll('.shade-item-variant').forEach((shade) => {
        shade.addEventListener('click', () => {
            let name = shade.dataset.name;
            let variant = document.querySelector(`.product-variants [data-variant-name="${name}"]`);
            if(variant) {
                variant.click();
            }
            document.querySelectorAll('.shade-item-variant.active').forEach((active_shade) => {
                active_shade.classList.remove('active');
            })
            document.querySelectorAll(`.shade-item-variant[data-name="${name}"]`).forEach((target_shade) => {
                target_shade.classList.add('active');
            })
            document.querySelector('.active-shade label').innerText = shade.dataset.value;
        })
    })

    let scent_dropdown = document.querySelector('.scent-dropdown');
    if(scent_dropdown) {
        document.documentElement.addEventListener('click', (e) => {
            if(e.target.closest('.active-scent')) {
                scent_dropdown.classList.toggle('visible');
            }
            else {
                scent_dropdown.classList.remove('visible');
            }
        })
    }

    document.querySelectorAll('.scent-item-variant').forEach((scent) => {
        scent.addEventListener('click', () => {
            let name = scent.dataset.name;
            let variant = document.querySelector(`.product-variants [data-variant-name="${name}"]`);
            if(variant) {
                variant.click();
                document.querySelector('.active-scent label').innerText = scent.dataset.value;
                document.querySelector('.active-scent .scent-image').setAttribute('data-name', `${scent.querySelector('.scent-image').dataset.name}`);
                document.querySelector('.scent-item-variant.active').classList.remove('active');
                scent.classList.add('active');
            }
            
        })
    })
    
}

initProductShadeToggle();


const initProductFaqToggle = () => {
    const btnShowMore = document.querySelector('.faq-show-more');
    const btnShowLess = document.querySelector('.faq-show-less');

    if(btnShowMore) {
        btnShowMore.addEventListener('click', () => {
        document.querySelectorAll('.pdp-section-faq .pdp-faq-item').forEach((item) => {
            item.classList.remove('hidden');
        })
        btnShowMore.classList.add('hidden');
        btnShowLess.classList.remove('hidden');
        })
    }

    if(btnShowLess) {
        btnShowLess.addEventListener('click', () => {
        document.querySelectorAll('.pdp-section-faq .pdp-faq-item').forEach((item) => {
            if(!item.classList.contains('default-show')) {
            item.classList.add('hidden');
            }
        })
        btnShowMore.classList.remove('hidden');
        btnShowLess.classList.add('hidden');
        })
    }

    document.querySelectorAll('[data-tabs-link]').forEach((tab) => {
        tab.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            let handle = tab.dataset.tabsLink;
            let target = document.querySelector(`[data-tabs-content-pane="${handle}"]`);
            tab.classList.toggle('is-active');
            target.classList.toggle('is-active');
        })
    })

}

initProductFaqToggle();


const initIframePlayPDP = () => {
    if (window.innerWidth > 768) {
        return;
    }
    document.querySelectorAll('.video-container .video-cover').forEach((overlay) => {
        overlay.addEventListener('click', (e) => {
            e.preventDefault();
            let activeOverlay = document.querySelector('.video-cover.active');
            if(activeOverlay && activeOverlay != overlay) {
                let activeIframe = activeOverlay.closest('.video-container').querySelector('iframe');
                activeOverlay.classList.remove('active');
                activeIframe.setAttribute('src', activeIframe.getAttribute('src').replace('&autoplay=1', ''));
            }

            let iframe = overlay.closest('.video-container').querySelector('iframe');
            overlay.classList.toggle('active');
            if(overlay.classList.contains('active')) {
                iframe.setAttribute('src', `${iframe.getAttribute('src')}&autoplay=1`);
            }
            else {
                iframe.setAttribute('src', iframe.getAttribute('src').replace('&autoplay=1', ''));
            }
        })
    })
}

initIframePlayPDP();


const updateSectionContent = async (is_media_only = false) => {

    const selector = {
        product_title: '.product-header-wrapper .product-title-main',
        product_type: '.product-header-wrapper .product-type',
        product_badge: '.product-badge-wrapper',
        pdp_media_main: '.gallery-main .swiper-wrapper',
        pdp_media_thumb: '.gallery-thumbs .swiper-wrapper',
        desc_content: '.product-desc-content',
        section_best_result: '#shopify-section-product-best-results',
        section_how_to_use: '#shopify-section-product-how-to-use',
        section_ingredient_card_flip: '#shopify-section-product-ingredient-card-flip',
        section_ingredient_info: '#shopify-section-product-ingredient-card-flip .info-wrapper',
        section_ingredient_swiper: '#shopify-section-product-ingredient-card-flip .swiper-wrapper',
        section_ingredients_popup: '#shopify-section-product-ingredient-card-flip .all-ingredients-popup',
        section_faq: '#shopify-section-product-faq [data-pdp-faq-content]'

    }

    const url = location.href;
    const response = await fetch(`${url}&view=sections`, {
        method: 'GET',
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        }
    });
    const result = await response.text();
    const doc = new DOMParser().parseFromString(result, 'text/html');

    document.querySelector(selector.pdp_media_main).innerHTML = doc.querySelector('[data-product-media-main]').innerHTML;
    document.querySelector(selector.pdp_media_thumb).innerHTML = doc.querySelector('[data-product-media-thumb]').innerHTML;
    document.querySelector(selector.product_badge).innerHTML = doc.querySelector('[data-product-badge]').innerHTML;

    initIframePlayPDP();

    if(!is_media_only) {
        document.querySelector(selector.product_title).innerHTML = doc.querySelector('[data-product-title]').innerHTML;
        document.querySelector(selector.product_type).outerHTML = doc.querySelector('[data-product-type]').innerHTML;
        document.querySelector(selector.desc_content).innerHTML = doc.querySelector(selector.desc_content).innerHTML;
        document.querySelector(selector.section_best_result).innerHTML = doc.querySelector(selector.section_best_result).innerHTML;
        document.querySelector(selector.section_how_to_use).innerHTML = doc.querySelector(selector.section_how_to_use).innerHTML;
    
        document.querySelector(selector.section_ingredient_info).innerHTML = doc.querySelector(selector.section_ingredient_info).innerHTML;
        document.querySelector(selector.section_ingredient_swiper).innerHTML = doc.querySelector(selector.section_ingredient_swiper).innerHTML;
        document.querySelector(selector.section_ingredients_popup).innerHTML = doc.querySelector(selector.section_ingredients_popup).innerHTML;

        document.querySelector(selector.section_faq).innerHTML = doc.querySelector(selector.section_faq).innerHTML;
        
        // document.querySelector(selector.section_ingredient_card_flip).innerHTML = doc.querySelector(selector.section_ingredient_card_flip).innerHTML;
    
        initProductDescToggle();
        initToggleMiniIngredient();
        // initProductShadeToggle();
        initTabBlocks();
        initBAslider();
        initClearForMe();
        ingredientCardFlip();
        jsQuickView();
        initProductFaqToggle();
    }
}

const initProductItemVariantExpand = () => {
    const el = {
        form: 'form.product-form',
        form_submit: '[data-ajax-cart-add-button]',
        wrapper: '.product-v-list-wrapper',
        list: '.product-v-list',
        item: '.product-v-list li',
        trigger: '.product-v-expand'
    }

    document.querySelectorAll(el.wrapper).forEach((wrapper) => {
        let trigger = wrapper.querySelector(el.trigger);
        let form = wrapper.closest(el.form);
        let form_id = form.querySelector('[name="id"]');

        wrapper.addEventListener('mouseover', () => {
            wrapper.classList.add('expanded');
        })
        wrapper.addEventListener('mouseleave', () => {
            wrapper.classList.remove('expanded');
        })
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
        })

        wrapper.querySelectorAll(el.item).forEach((item) => {
            item.addEventListener('click', () => {
                let id = item.dataset.id;
                form_id.value = id;
                form.querySelector(el.form_submit).click();
            })
        })
        if(window.innerWidth > 768) {
            trigger.addEventListener('click', () => {
                form.querySelector(el.form_submit).click();
            })
        }
    })
}

initProductItemVariantExpand();